import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { randomSort, setId } from '@/lib/utils'
import { Action } from '@@/action_pb'
import { eventLogProducer } from '@/lib/event-logger'

const HotTag = (params: { tags: any[] }) => {
  const tags = params.tags.sort(randomSort).slice(0, 20)
  const eventClick = (name: string) => {
    eventLogProducer.push({
      action: Action.HOTSEARCHWORDCLICK,
      extra: { queryWords: name },
    })
  }
  return (
    <BannerBox>
      <p className="hot-title">Hot Search</p>
      <div className="tag-hook">
        {tags?.map((item) => {
          return (
            <Link href={`/education-tag/${item.slug}`} key={item.id}>
              <a className="tag" onClick={() => setId(item.id)}>
                <div
                  dangerouslySetInnerHTML={{ __html: item.name }}
                  onClick={() => {
                    eventClick(item.name)
                  }}
                ></div>
              </a>
            </Link>
          )
        })}
      </div>
    </BannerBox>
  )
}

export default HotTag

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 32px;
    padding: 0 24px;
    .hot-title {
      font-size: 18px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #212121;
      padding-bottom: 12px;
      text-align: left;
    }
    .tag-hook {
      display: flex;
      flex-wrap: wrap;
      max-height: 300px;
      overflow-y: auto;
      .tag {
        background: #fff;
        border-radius: 8px;
        padding: 12px 16px;
        font-size: 14px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #959ead;
        margin: 16px 16px 16px 0;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    margin-top: 32px;
    .hot-title {
      font-size: 18px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #212121;
    }
    .tag-hook {
      display: flex;
      flex-wrap: wrap;
      max-height: 360px;
      overflow-y: auto;
      .tag {
        background: #fff;
        border-radius: 8px;
        padding: 12px 16px;
        font-size: 14px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #959ead;
        margin: 16px 16px 16px 0;
      }
    }
  }
`
